import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bool, func, string } from "prop-types";
import React, { useCallback, useEffect, useState } from "react";

import styled from "styled-components/macro";

import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import { AnimatePresence, motion } from "framer-motion";

import { colors } from "UI/colors";

import { WrapperVerticalPadding } from "../styles";

import MemoForm from "./MemoForm";

Memo.propTypes = {
  onRemoveMemo: func,
  onUpdateMemo: func,
  initialContent: string,
  hasHorizontalMargin: bool,
  disabled: bool,
};

export default function Memo({
  onRemoveMemo,
  onUpdateMemo,
  initialContent,
  hasHorizontalMargin,
  disabled,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [initial, setInitial] = useState(true);

  useEffect(() => {
    if (!initialContent) return;
    setIsOpen(true);
  }, [initialContent]);

  const removeMemo = useCallback(() => {
    onRemoveMemo();
    setIsOpen(false);
  }, [onRemoveMemo, setIsOpen]);

  const focusInput = () => {
    if (!isOpen) return;

    let input = document.querySelector(".fundit-memo");
    input.focus();
  };

  return (
    <div>
      <Wrapper isOpen={isOpen} hasHorizontalMargin={hasHorizontalMargin}>
        <Parent
          // layout={true}
          data-isopen={isOpen}
          className="parent"
          initial={{
            backgroundColor: !isOpen ? "hsl(0, 0%, 100%)" : "hsl(0, 0%, 90%)",
            width: isOpen ? "130px" : "100%",
            transition: { duration: 0.3 },
          }}
          animate={{
            backgroundColor: isOpen ? "hsl(0, 0%, 100%)" : "hsl(0, 0%, 90%)",
            width: !isOpen ? "130px" : "100%",
            transition: { duration: 0.3 },
          }}
          onClick={focusInput}
        >
          <AnimatePresence>
            {isOpen ? (
              <MemoForm
                setIsOpen={setIsOpen}
                placeholder="add memo here"
                onUpdate={onUpdateMemo}
                onRemove={removeMemo}
                initialContent={initialContent}
              ></MemoForm>
            ) : (
              <Button
                onClick={() => {
                  setIsOpen(true);
                  setInitial(false);
                }}
                initial={{ opacity: initial ? 1 : 0, scale: initial ? 1 : 0.5 }}
                animate={{ opacity: 1, scale: 1, transition: { delay: 0.3 } }}
                exit={{ opacity: 0 }}
                disabled={disabled}
              >
                <FontAwesomeIcon
                  icon={faPlusCircle}
                  style={{ marginRight: "5px" }}
                />
                Add a Memo
              </Button>
            )}
          </AnimatePresence>
        </Parent>
      </Wrapper>

      <WrapperVerticalPadding />
    </div>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-left: ${(props) =>
    !props.hasHorizontalMargin
      ? "auto"
      : props.isOpen
      ? "min(28px, 8%)"
      : "auto"};
  margin-right: ${(props) =>
    !props.hasHorizontalMargin
      ? "auto"
      : props.isOpen
      ? "min(28px, 8%)"
      : "auto"};

  @media screen and (max-width: 420px) {
    margin-left: ${(props) =>
      !props.hasHorizontalMargin
        ? "auto"
        : props.isOpen
        ? "min(20px, 6%)"
        : "auto"};
    margin-right: ${(props) =>
      !props.hasHorizontalMargin
        ? "auto"
        : props.isOpen
        ? "min(20px, 6%)"
        : "auto"};
  }
`;

const Parent = styled(motion.div)`
  width: 130px;
  font-weight: 400;
  border-radius: 50px;

  &[data-isopen="false"] {
    /* transform: none !important;
    transform-origin: none !important; */
  }

  &[data-isopen="true"] {
    width: 100%;
    /* background: white; */
    box-shadow: 0 8px 24px 0 #eeeeeeff, 0 4px 8px 0 #42474c0f,
      0 0 1px 0 #42474c52;
    border-radius: 14px;
  }
`;

const Button = styled(motion.button)`
  width: 130px;
  text-align: center;
  background: none;
  border: none;
  color: ${(p) => (p.disabled ? colors.fnGray : "#767676")};
  padding: 10px;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  font-weight: 400;
  transition: scale 0.25s ease-in-out;

  &:hover {
    ${(p) => !p.disabled && "scale: 1.05;"}
  }
`;
